// Discovery tier. `network` is the parent-network-scoped tier: only members
// of the circle's parent network can find the row or open its page, which is
// what a company network needs — employees self-select circles after joining
// the network, and nobody outside it can even see them. Structurally it only
// applies to a circle with a `parentGroupId`; the read predicates reduce it
// to "no one but platform admins" for a network or an orphan circle, and the
// write boundary rejects setting it on one.
//
// `network_leaders` is the mirror image for networks: the row is visible only
// to people who lead some network (plus platform admins). It exists for
// org-run leader spaces like the Network Leaders Hub. Only networks can carry
// it, and only platform admins may set or clear it — a network leader must
// not be able to widen or narrow a staff-run audience.
//
// Exported as a tuple so the server's request and response zod enums both
// derive from it (same pattern as `REGIONS`) — the two used to restate the
// literals independently, which is how a fourth tier could reach the DB while
// the wire contract still rejected it.
// The largest capacity an event can take (the event create and update
// requests, and the event forms).
export const EVENT_CAPACITY_MAX = 100_000;
export const GROUP_ACCESS_TIERS = [
    'public',
    'unlisted',
    'private',
    'network',
    'network_leaders',
];
//# sourceMappingURL=event.js.map